import { apiFetch } from "./client";
import type { Template, TemplateConfig, UpdateTemplateInput } from "@/lib/template-types";
import type { ViewConfig } from "@/lib/views";

export type { Template, TemplateConfig };

export async function fetchTemplates(): Promise<{ templates: Template[]; categories: string[] }> {
  return apiFetch<{ templates: Template[]; categories: string[] }>("/api/templates");
}

export async function fetchTemplate(id: string): Promise<Template> {
  return apiFetch<Template>(`/api/templates/${encodeURIComponent(id)}`);
}

export async function createTemplate(input: {
  name: string;
  icon?: string | null;
  description?: string;
  category?: string;
  config: TemplateConfig;
}): Promise<Template> {
  return apiFetch<Template>("/api/templates", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateTemplate(
  id: string,
  patch: UpdateTemplateInput,
): Promise<Template> {
  return apiFetch<Template>(`/api/templates/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export async function deleteTemplate(id: string): Promise<void> {
  await apiFetch(`/api/templates/${encodeURIComponent(id)}`, { method: "DELETE" });
}

/** Применить шаблон — создаёт новый view у текущего пользователя. */
export async function applyTemplate(id: string): Promise<ViewConfig> {
  return apiFetch<ViewConfig>(`/api/templates/${encodeURIComponent(id)}/apply`, {
    method: "POST",
  });
}
